import {PaymentInfo} from '@wix/auto_sdk_ecom_current-cart-v-2';

export class PaymentInfoModel {
  public currencyCode: string;

  constructor(params: PaymentInfoModel) {
    this.currencyCode = params.currencyCode;
  }

  public static fromCartV1(currencyCode: string): PaymentInfoModel {
    return new PaymentInfoModel({currencyCode});
  }

  public static fromCartV2(paymentInfo: PaymentInfo): PaymentInfoModel {
    return new PaymentInfoModel({currencyCode: paymentInfo.currencyCode});
  }
}
